import { render, staticRenderFns } from "./jx4.vue?vue&type=template&id=9a517f26&"
import script from "./jx4.vue?vue&type=script&lang=js&"
export * from "./jx4.vue?vue&type=script&lang=js&"
import style0 from "./jx4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports